export const UI_FORMAT = 'MMM DD, YYYY - ddd'
export const DATE_FORMAT_WITH_TIME = 'DD MMM, YY - h:mm a'



// WEBPACK FOOTER //
// ./src/constants/DateConstants.js